import axiosInstance from '../utils/AxiosConfig';

const unwrap = (response) => response.data?.data ?? response.data;

export const getPaymentProviderConfiguration = async (locationId) => {
  const response = await axiosInstance.get(`/payment-providers/${locationId}`);
  return unwrap(response);
};

export const savePaymentProviderAccount = async (locationId, payload) => {
  const response = await axiosInstance.put(`/payment-providers/${locationId}/accounts`, payload);
  return unwrap(response);
};

export const savePaymentProviderTerminal = async (locationId, terminalId, payload) => {
  const response = await axiosInstance.put(`/payment-providers/${locationId}/terminals/${terminalId}`, payload);
  return unwrap(response);
};

/**
 * Write-only: the backend stores the account's secrets in AWS Secrets Manager and never returns them.
 * [values] maps each of the provider's `credentialFields` keys to its value.
 */
export const savePaymentProviderCredentials = async (locationId, accountId, values) => {
  const response = await axiosInstance.put(`/payment-providers/${locationId}/accounts/${accountId}/credentials`, { values });
  return unwrap(response);
};

/**
 * The terminals the provider's account has, to pick from instead of typing the id: `[{ id, operatingMode, ready }]`.
 * [accountId] is the saved account (its own credentials, if any); omit it when none is saved yet.
 */
export const getPaymentProviderTerminals = async (locationId, provider, accountId) => {
  const response = await axiosInstance.get(`/payment-providers/${locationId}/providers/${provider}/terminals`, {
    params: accountId ? { accountId } : undefined,
    skipGlobalErrorRedirect: true,
  });
  const terminals = unwrap(response);
  return Array.isArray(terminals) ? terminals : [];
};

export const deletePaymentProviderTerminalConfiguration = async (locationId, mappingId) => {
  const response = await axiosInstance.delete(`/payment-providers/${locationId}/terminal-configurations/${mappingId}`);
  return unwrap(response);
};
